import { ReactNode } from "react";
import { useHistory, useLocation } from "react-router-dom";
import styles from "./Table.module.css";

export interface TableLinkProps {
  to: string;
  children: ReactNode;
  fromDashboard?: boolean;
  onClick?: () => void;
}

export const TableLink = ({
  to,
  children,
  fromDashboard,
  onClick,
}: TableLinkProps) => {
  const history = useHistory();
  const location = useLocation();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    if (!fromDashboard) {
      history.push(to);
    } else {
      history.push({
        ...location,
        pathname: `/adminportal/${to}`,
        search: "",
      });
    }
  };

  return (
    <button type="button" onClick={handleClick} className={styles.tableLink}>
      {children}
    </button>
  );
};
export default TableLink;
